import { z } from 'zod';
/**
 * Notification severity levels for alert notifications.
 * Controls the minimum severity threshold for showing popup/toast notifications.
 *
 * Values:
 * - Low: Notify on all alerts
 * - Medium: Notify on medium, high, and critical
 * - High: Notify on high and critical only
 * - Critical: Notify on critical only
 * - ActionsOnly: Notify only when an automatic action (quarantine/block) is taken
 * - None: Do not notify on alerts
 */
export var NotificationSeverityLevel;
(function (NotificationSeverityLevel) {
    NotificationSeverityLevel["Low"] = "low";
    NotificationSeverityLevel["Medium"] = "medium";
    NotificationSeverityLevel["High"] = "high";
    NotificationSeverityLevel["Critical"] = "critical";
    NotificationSeverityLevel["ActionsOnly"] = "actions_only";
    NotificationSeverityLevel["None"] = "none";
})(NotificationSeverityLevel || (NotificationSeverityLevel = {}));
export const notificationSeveritySchema = z.nativeEnum(NotificationSeverityLevel);
/**
 * Response schema for notification settings.
 * Used for both personal and organization settings endpoints.
 *
 * Note: organizationId is NOT in the response - scope is implicit from the endpoint called.
 */
export const notificationSettingsResponseSchema = z.object({
    minAlertSeverity: notificationSeveritySchema,
    updatedAt: z.coerce.date().optional(),
});
/**
 * Request body schema for updating notification settings.
 * Used for both personal and organization settings endpoints.
 */
export const updateNotificationSettingsBodySchema = z.object({
    minAlertSeverity: notificationSeveritySchema,
});
//# sourceMappingURL=notification-settings.js.map